<div class="critical-alerts">
  <div *ngIf="!(isBnB || isBnBCyberSite || isMidMarket)" class="lato-18-n-vw uppercase title">
    Critical Alerts</div>

  <div class="horizontal-separator">
    <div class="separator-line"></div>
  </div>

  <div [ngClass]="{ 'section-list-bnb':  isBnB || isBnBCyberSite || isMidMarket }"
    class="section-list">
    <section class="section">
      <div class="lato-14-n-vw uppercase label">{{ criticalAlertTypeEnum.TREATS }}</div>
      <div class="accordion-list"
        *ngIf="alertMap?.[criticalAlertTypeEnum.TREATS]?.length; else noMessages">
        <div class="panel" *ngFor="let alert of alertMap[criticalAlertTypeEnum.TREATS]"
          [ngClass]="{ hide: alert.hidden }"
          (click)="togglePanel($event, criticalAlertTypeEnum.TREATS, alert)">
          <div class="content-wrapper">
            <div #contentEl class="lato-14-n-vw content">{{ alert.content | capitalizeFirst }}</div>
            <span *ngIf="isOverflowing(contentEl)" class="ellipsis-blue">...</span>
          </div>
          <div class="arrow-right" *ngIf="!alert.open" cygovSvgIcon [svgName]="'arrow-right-type1'">
          </div>
          <div class="arrow-right" *ngIf="alert.open" cygovSvgIcon [svgName]="'arrow-down-type1'">
          </div>
        </div>
      </div>

      <ng-template #noMessages>
        <div class="alerts-skeleton" *ngIf="loading">
          <cygov-skeleton width="100%" height="1.2vh" [count]="3" [gap]="alertSkeletonGap">
          </cygov-skeleton>
        </div>
        <div class="lato-16-n-vw" *ngIf="!loading">No messages to display.</div>
      </ng-template>
    </section>
    <section class="section">
      <div class="lato-14-n-vw uppercase label">{{ criticalAlertTypeEnum.VULNERABILITIES }}</div>
      <div class="accordion-list"
        *ngIf="alertMap?.[criticalAlertTypeEnum.VULNERABILITIES]?.length; else noMessages">
        <div class="panel" *ngFor="let alert of alertMap[criticalAlertTypeEnum.VULNERABILITIES]"
          [ngClass]="{ hide: alert.hidden }"
          (click)="togglePanel($event, criticalAlertTypeEnum.VULNERABILITIES, alert)">
          <div class="content-wrapper">
            <div #contentEl class="lato-14-n-vw content">{{ alert.content | capitalizeFirst }}</div>
            <span *ngIf="isOverflowing(contentEl)" class="ellipsis-blue">...</span>
          </div>
          <div class="arrow-right" *ngIf="!alert.open" cygovSvgIcon [svgName]="'arrow-right-type1'">
          </div>
          <div class="arrow-right" *ngIf="alert.open" cygovSvgIcon [svgName]="'arrow-down-type1'">
          </div>
        </div>
      </div>

      <ng-template #noMessages>
        <div class="alerts-skeleton" *ngIf="loading">
          <cygov-skeleton width="100%" height="1.2vh" [count]="3" [gap]="alertSkeletonGap">
          </cygov-skeleton>
        </div>
        <div class="lato-16-n-vw" *ngIf="!loading">No messages to display.</div>
      </ng-template>
    </section>
    <section class="section">
      <div class="lato-14-n-vw uppercase label">{{ criticalAlertTypeEnum.REGULATIONS }}</div>
      <div class="accordion-list"
        *ngIf="alertMap?.[criticalAlertTypeEnum.REGULATIONS]?.length; else noMessages">
        <div class="panel" *ngFor="let alert of alertMap[criticalAlertTypeEnum.REGULATIONS]"
          [ngClass]="{ hide: alert.hidden }"
          (click)="togglePanel($event, criticalAlertTypeEnum.REGULATIONS, alert)">
          <div class="content-wrapper">
            <div #contentEl class="lato-14-n-vw content">{{ alert.content | capitalizeFirst }}</div>
            <span *ngIf="isOverflowing(contentEl)" class="ellipsis-blue">...</span>
          </div>
          <div class="arrow-right" *ngIf="!alert.open" cygovSvgIcon [svgName]="'arrow-right-type1'">
          </div>
          <div class="arrow-right" *ngIf="alert.open" cygovSvgIcon [svgName]="'arrow-down-type1'">
          </div>
        </div>

        <div *ngIf="alertMap['regulations'].length == 2" class="fix-entry"></div>
      </div>

      <ng-template #noMessages>
        <div class="alerts-skeleton" *ngIf="loading">
          <cygov-skeleton width="100%" height="1.2vh" [count]="3" [gap]="alertSkeletonGap">
          </cygov-skeleton>
        </div>
        <div class="lato-16-n-vw" *ngIf="!loading">No messages to display.</div>
      </ng-template>
    </section>
  </div>
</div>